import { Component, OnInit } from '@angular/core';
import { ManifestService } from 'src/app/core/services/manifest.service';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.css'],
})
export class LegalComponent implements OnInit {
  version: string = '';
  link_lang: string = 'en-us';

  constructor(private manifestService: ManifestService) {}

  ngOnInit(): void {
    if (window.location.pathname.toLowerCase().includes('/fr')) {
      this.link_lang = 'fr-fr';
    }
    this.manifestService.getManifestData().subscribe((data) => {
      this.version = data.UDIVersion;
    });
  }
}
